import { isServerSide } from "app/utils/utils";

declare global {
	interface Window {
		__VERSION__?: string;
	}
}

/**
 * Returns the current release version injected on the window, or undefined on the server.
 */
export const useReleaseVersion = (): string | undefined => {
	if (isServerSide) {
		return undefined;
	}

	return window.__VERSION__;
};
